import { capitalizeFirstLetter } from 'src/utils/string';

import TourController from '../TourController/TourController';
import { Button } from 'reactstrap';

function ProactiveTourBox({
  intl,
  title,
  description,
  onSeeLater,
  onClose,
  onCloseTour,
  setOpenHelp,
  steps,
  path,
  tourName,
}) {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 40,
        right: 40,
        zIndex: 100,
        border: '1px solid #1d7789',
        borderRadius: 8,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        padding: 24,
        minWidth: 330,
        maxWidth: 410,
        color: '#f8f9fa',
        backgroundColor: '#1d7789',
        borderColor: '#1d7789',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: '#f8f9fa',
        }}
      >
        <p style={{ margin: 0, color: '#f8f9fa', fontWeight: 'bold', fontSize: 15 }}>{title}</p>
        <Button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            fontSize: 18,
            cursor: 'pointer',
            lineHeight: 1,
          }}
          aria-label="Fechar"
        >
          ×
        </Button>
      </div>
      <div style={{ margin: '16px 0 24px 0', color: '#f8f9fa' }}>
        {description}
      </div>
      <div style={{ display: 'flex', gap: 14 }}>
        <TourController
          setOpenHelp={setOpenHelp}
          redirectPath={path}
          steps={steps}
          tourName={tourName}
          onClose={onCloseTour}
          ehProactiveTour={true}
        />
        <Button
          onClick={onSeeLater}
          style={{
            backgroundColor: '#1d7789',
            color: '#f8f9fa',
            border: '1px solid #1d7789',
            borderRadius: 4,
            padding: '8px 16px',
            cursor: 'pointer',
          }}
        >
          {capitalizeFirstLetter(intl.formatMessage({ id: 'verMaisTarde' }))}
        </Button>
      </div>
    </div>
  );
}

export default ProactiveTourBox;
